export type { RecordCategory, RecordInput, LinkCandidate, ExtractResult } from "./types.js";
export { extractDeterministic } from "./deterministic.js";

import type { ExtractResult, RecordInput } from "./types.js";

/**
 * LLM enrichment (Phase 1 §4 step 3) — runs ONLY on changed, weakly-structured
 * files after deterministic extraction shows gaps, proposing typed relations
 * with confidence + evidence (never auto-confirmed).
 *
 * TODO(phase1): implement against the host LLM. The skeleton is a pass-through.
 */
export function enrichWithLlm(_record: RecordInput, deterministic: ExtractResult): ExtractResult {
  return deterministic;
}
